import { noop } from 'ui-components/default-props/noop';

import { UpsellModalLayout } from '../upsell-modal-layout/upsell-modal-layout';
import { AddOnDescription } from './add-on-description';
import { AddOnFooter } from './add-on-footer';
import { UpsellModalImage } from '../modal-svgs/upsell-modal-image';
import { DEFAULT_TRIAL_LENGTH_IN_DAYS } from '../../../constants/add-ons';
import { isAddOnAvailableForTrial } from '../../../pages/settings/add-on-marketplace/helpers';

import type { AddOn } from '../types';
import type { UpsellModalContentCode } from '../../../constants/upsell-modal-content-codes';

type AddOnUpsellModalProps = {
  addOn: AddOn;
  upsellModalContentCode: UpsellModalContentCode;
  onClose: () => void;
  onCancel?: () => void;
  onError?: (addOnCode: string) => void;
};

export const AddOnUpsellModal = ({ addOn, upsellModalContentCode, onClose, onCancel, onError = noop }: AddOnUpsellModalProps) => {
  const canTrial = isAddOnAvailableForTrial(addOn);
  const trialLengthInDays = addOn?.defaultTrialPeriodInDays ?? DEFAULT_TRIAL_LENGTH_IN_DAYS;

  return (
    <UpsellModalLayout
      descriptionContent={
        <AddOnDescription
          addOnPrice={addOn.price}
          canTrial={canTrial}
          trialLengthInDays={trialLengthInDays}
          upsellModalContentCode={upsellModalContentCode}
        />
      }
      footerContent={<AddOnFooter addOn={addOn} canTrial={canTrial} onCloseModal={onClose} onError={onError} />}
      imageContent={<UpsellModalImage upsellModalContentCode={upsellModalContentCode} />}
      onCancel={onCancel}
      onClose={onClose}
    />
  );
};
